<template>
  <td class="right">
    <template v-if="removeDiff?.length">
      <span
        v-if="removeDiff?.length > MAX"
        class="badge badge-info-hollow clickable"
        @click="() => toggle(REMOVE)">
        {{ removeTotal }} {{ displayAllRemoval ? '&#x25B2;' : '&#x25BC;' }}
      </span>

      <template v-if="displayAllRemoval">
        <span
          v-for="change in removeDiff"
          :key="change.key"
          class="badge badge-danger-hollow">
          {{ change.value }}
        </span>
      </template>
    </template>

    <entity-change-list-empty v-else />
  </td>

  <td></td>

  <td class="left">
    <template v-if="addDiff?.length">
      <span
        v-if="addDiff?.length > MAX"
        class="badge badge-info-hollow clickable"
        @click="() => toggle(ADD)">
        {{ addTotal }} {{ displayAllAddition ? '&#x25B2;' : '&#x25BC;' }}
      </span>

      <template v-if="displayAllAddition">
        <span
          v-for="change in addDiff"
          :key="change.key"
          class="badge badge-success-hollow">
          {{ change.value }}
        </span>
      </template>
    </template>

    <entity-change-list-empty v-else />
  </td>
</template>

<script lang="ts" setup>
  import { IChange } from 'json-diff-ts';
  import { computed, onMounted, ref } from 'vue';

  import formatNumber from '@/utils/NumberFormatter';

  import EntityChangeListEmpty from './EntityChangeListEmpty.vue';

  interface IProps {
    diff: IChange[];
    field: string;
  }

  const ADD = 'ADD';
  const REMOVE = 'REMOVE';
  const MAX = 10;

  const { diff, field } = defineProps<IProps>();

  const displayAllAddition = ref(true);
  const displayAllRemoval = ref(true);

  const removeDiff = computed(() => [...diff].filter((d) => d.type === REMOVE));
  const addDiff = computed(() => [...diff].filter((d) => d.type === ADD));

  const removeTotal = computed(() => formatTotal(removeDiff.value.length));
  const addTotal = computed(() => formatTotal(addDiff.value.length));

  function formatTotal(num: number): string {
    return `${formatNumber(num)} ${field.toLowerCase()}`;
  }

  function toggle(type: string) {
    if (type === ADD) {
      displayAllAddition.value = !displayAllAddition.value;
    }

    if (type === REMOVE) {
      displayAllRemoval.value = !displayAllRemoval.value;
    }
  }

  onMounted(() => {
    displayAllAddition.value = addDiff.value?.length <= MAX;
    displayAllRemoval.value = removeDiff.value?.length <= MAX;
  });
</script>

<style lang="scss" scoped>
  td {
    span {
      margin-bottom: 1rem;

      &.clickable {
        cursor: pointer;

        &:hover {
          opacity: 0.5;
        }
      }
    }

    &.left {
      text-align: left;

      span {
        margin-left: 1rem;
      }
    }

    &.right {
      text-align: right;

      span {
        margin-right: 1rem;
      }
    }
  }
</style>
